import { render, staticRenderFns } from "./scroll-to-button.vue?vue&type=template&id=e234c0c8"
import script from "./scroll-to-button.vue?vue&type=script&lang=js"
export * from "./scroll-to-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports